import DisconnectedIllustration from '@/assets/f5-illustrations/disconnected.svg';
import RestrictedAccessIllustration from '@/assets/f5-illustrations/restricted-access.svg';
import ServerErrorIllustration from '@/assets/f5-illustrations/server-error.svg';
import UserAccessIllustration from '@/assets/f5-illustrations/user-access.svg';

export type IllustrationType =
  | 'disconnected'
  | 'restricted-access'
  | 'server-error'
  | 'user-access';

export type IllustrationSize = 'xs' | 'small' | 'medium' | 'large' | 'xl';

export const IllustrationMap: Record<IllustrationType, string> = {
  disconnected: DisconnectedIllustration,
  'restricted-access': RestrictedAccessIllustration,
  'server-error': ServerErrorIllustration,
  'user-access': UserAccessIllustration,
};

export const IllustrationSizes: Record<IllustrationSize, number> = {
  xs: 64,
  small: 96,
  medium: 164,
  large: 288,
  xl: 464,
};
